import { LoadingOutlined } from "@ant-design/icons";
import { CHAT_GLYPH } from "@axl/site-chat/src/school/mountSchoolChat";
import { FC } from "react";

import { useChat } from "@app/features/chat/ChatProvider";
import { useLoc } from "@app/shared/lib/hooks";
import { ShellIconButton } from "@app/shared/ui/AppShell/ShellIconButton";

/** Toggles the school's membership chat; renders nothing when the school has none. */
export const Chat: FC<{ className?: string }> = ({ className }) => {
  const chat = useChat();
  const loc = useLoc();

  if (!chat.chatController) return null;

  return (
    <ShellIconButton
      testId="header-chat-button"
      className={className}
      label={loc.word("School.nav.chat", { default: "Chat" })}
      icon={
        !chat.isChatInited ? (
          <LoadingOutlined />
        ) : chat.icon ? (
          // the launcher image chosen in the website chat's settings, as on the school's site
          <img src={chat.icon} alt="" className="shell-chat-icon" />
        ) : (
          // the website chat's own launcher bubble, so the button matches the chat on the school's site
          <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
            <path d={CHAT_GLYPH} />
          </svg>
        )
      }
      count={chat.unreadCount}
      onClick={() => {
        if (chat.chatController?.visible) chat.chatController.close();
        else chat.chatController?.open();
      }}
    />
  );
};
